module.exports = __webpack_public_path__ + "static/media/moraine-22.c1de76e9.jpg";